import FilasDrug from './FilasDrug';
import CollapsibleSection from './CollapsibleSection';
import { useState } from 'react';

export default function DetailDrug({ values }) {
  const {
    chemSynonyms,
    chemVocabularies,
    chemVocabulariesCrossreferences,
    chemID,
    chemMoleculeType,
    chemPrefName,
  } = values;

  const [showAll, setShowAll] = useState(false);

  return (
    <div className="space-y-0">
      <CollapsibleSection title="General Info" defaultOpen>
        <table className="table table-sm mb-0">
          <tbody>
            <tr>
              <td className="text-xs text-semibold">
                <strong>Chembl ID:</strong>
              </td>
              <td className="text-xs text-semibold">
                <a
                  href={`https://www.ebi.ac.uk/chembl/explore/compound/${chemID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chemID} <i className="fa fa-external-link" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
            <tr>
              <td className="text-xs text-semibold">
                <strong>Name:</strong>
              </td>
              <td className="text-xs text-semibold">{chemPrefName}</td>
            </tr>
            <tr>
              <td className="text-xs text-semibold">
                <strong>Type:</strong>
              </td>
              <td>{chemMoleculeType}</td>
            </tr>
          </tbody>
        </table>
      </CollapsibleSection>

      <CollapsibleSection title="Vocabulary" defaultOpen>
        <table className="table table-sm mb-0">
          <tbody>
            {chemVocabulariesCrossreferences?.map(ref => {
              const [left, right] = ref.split('_');
              const vocab = chemVocabularies.find(v => v.vocabulary === left);
              const resultado = vocab?.code;
              const lista = vocab?.code === chemID ? chemPrefName : vocab?.name;

              if (!left || !resultado || !lista) return null;

              return (
                <FilasDrug
                  key={ref}
                  left={left.toUpperCase()}
                  resultado={resultado}
                  lista={lista}
                ></FilasDrug>
              );
            })}
          </tbody>
        </table>
      </CollapsibleSection>

      <CollapsibleSection title="Synonyms" defaultOpen>
      <table className="table table-sm mb-0">
        <tbody>
          {(showAll ? chemSynonyms : chemSynonyms.slice(0, 10)).map(
            (synonym, index) => (
              <tr key={`ChemSynonym${index}`}>
                <td className="col-md-6 text-xs font-semibold">{synonym}</td>
              </tr>
            )
          )}

          {chemSynonyms.length > 10 && !showAll && (
            <tr>
              <td className="text-left">
                <button
                  style={{ color: 'rgb(107, 151, 208)' }}
                  className="text-xs font-semibold"
                  onClick={() => setShowAll(true)}
                >
                  +{chemSynonyms.length - 10} synonyms
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </CollapsibleSection>
    </div>
  );
}
